import type { IconDefinition, IconProp } from '@fortawesome/fontawesome-svg-core'
import Icon from '@space-core/components/icon'
import { ThemeMode } from '@space-core/styles/themes/enum'
import clsx from 'clsx'
import styled from 'styled-components'

import '@hotmart/cosmos/dist/form/form.css'
import '@hotmart/cosmos/dist/form/input-custom.css'
import '@hotmart/cosmos/dist/form/input-switch.css'

export type SwitchProps = {
  children?: React.ReactNode
  label?: string
  handleClick: () => void
  className?: string
  theme?: string
  icon?: IconDefinition
}

const StyledLabel = styled.label`
  &:hover {
    background-color: var(--gray-200);
  }
`

const Switch = ({ children, label, handleClick, className, theme, icon }: SwitchProps) => {
  const switchClass = clsx('hot-form', 'hot-form--custom', 'hot-form--switch', className)

  return (
    <StyledLabel
      className='hot-form__label _m-0 _py-4 _d-flex _justify-content-between _text-gray-900 _cursor-pointer'
      htmlFor='switchTheme'
      data-test='label-switch-theme'
      aria-label='text'>
      <div className='_d-flex _align-items-center'>
        <Icon icon={icon as IconProp} className='_mr-2 _text-4' />
        {label}
      </div>
      <div className={switchClass}>
        <input
          type='checkbox'
          defaultChecked={theme !== ThemeMode.LIGHT}
          onChange={handleClick}
          className='hot-form__input'
          id='switchTheme'
          data-test='input-switch-theme'
        />
        <label className='hot-form__label' htmlFor='switchTheme' aria-label='input'>
          {children}
        </label>
      </div>
    </StyledLabel>
  )
}

export default Switch
